import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { handleAPIError } from '@/utils/handle-api-error';
import { previewLicenseSeatsAction } from '@/redux/actions/company';
import { previewLicenseSeats, TPreviewLicenseSeatsResponse } from '@/services/api/company';

export function* previewLicenseSeatsSaga(action: ActionType<typeof previewLicenseSeatsAction.request>): Generator {
  const { materials, successCallback, failedCallback } = action.payload;
  try {
    const response = yield call(previewLicenseSeats, materials);
    const previewResponse: TPreviewLicenseSeatsResponse = response as TPreviewLicenseSeatsResponse;
    yield put(previewLicenseSeatsAction.success(previewResponse));
    successCallback?.(previewResponse);
  } catch (err) {
    handleAPIError(err, 'Billing.addSeatsPreviewError');
    yield put(previewLicenseSeatsAction.failure(err));
    failedCallback?.(err);
  }
}
